export type LatLngLiteral = { lat: number; lng: number };

const CIRCLE_APPROX_POINTS = 32;

export const polygonCoordsToWkt = (coords: LatLngLiteral[]) => {
  if (!coords.length) return '';
  const first = coords[0];
  const last = coords[coords.length - 1];
  const closedCoords =
    first.lat === last.lat && first.lng === last.lng
      ? coords
      : [...coords, first];
  const wktCoords = closedCoords.map((coord) => `${coord.lng} ${coord.lat}`);
  return `POLYGON ((${wktCoords.join(', ')}))`;
};

export const circleToPolygonWkt = (
  center: LatLngLiteral,
  radius: number,
  points: number = CIRCLE_APPROX_POINTS
) => {
  const coordinates: LatLngLiteral[] = [];
  for (let i = 0; i <= points; i++) {
    const angle = (i / points) * 2 * Math.PI;
    const dx = radius * Math.cos(angle);
    const dy = radius * Math.sin(angle);
    const lat = center.lat + dy / 111320;
    const lng = center.lng + dx / (111320 * Math.cos((center.lat * Math.PI) / 180));
    coordinates.push({ lat, lng });
  }
  return polygonCoordsToWkt(coordinates);
};
